import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaArrowLeft,
  FaMoneyBillWave,
  FaBitcoin,
  FaGlobe,
  FaChevronRight,
} from "react-icons/fa";

import "./Deposit.css";

// Bandika const translations = { ... }; hapa juu ya Deposit
const translations = {
// English
en: {
  deposit: "Deposit",
  depositMobileMoney: "Deposit Mobile Money",
  depositMobileMoneyDesc:
    "Deposit instantly using M-Pesa, Airtel Money, Tigo Pesa or HaloPesa.",
  crypto: "Crypto",
  cryptoDesc: "Transfer crypto from another wallet or exchange.",
  allCountry: "All Country",
  allCountryDesc: "Choose deposit methods available for your country.",
},

// French                              
fr: {
  deposit: "Dépôt",
  depositMobileMoney: "Dépôt par mobile money",
  depositMobileMoneyDesc:
    "Déposez instantanément avec M-Pesa, Airtel Money, Tigo Pesa ou HaloPesa.",
  crypto: "Cryptomonnaie",
  cryptoDesc: "Transférez des cryptomonnaies depuis un autre portefeuille ou une plateforme d'échange.",
  allCountry: "Tous les pays",
  allCountryDesc: "Choisissez les méthodes de dépôt disponibles dans votre pays.",
},

// Swahili
sw: {
  deposit: "Weka Pesa",
  depositMobileMoney: "Weka Pesa kwa Simu",
  depositMobileMoneyDesc:
    "Weka pesa papo hapo kwa kutumia M-Pesa, Airtel Money, Tigo Pesa au HaloPesa.",
  crypto: "Sarafu za Kidijitali",
  cryptoDesc: "Hamisha sarafu za kidijitali kutoka pochi au soko lingine.",
  allCountry: "Nchi Zote",
  allCountryDesc: "Chagua njia za kuweka pesa zinazopatikana katika nchi yako.",
},

// Portuguese
pt: {
  deposit: "Depositar",
  depositMobileMoney: "Depósito por dinheiro móvel",
  depositMobileMoneyDesc:
    "Deposite instantaneamente usando M-Pesa, Airtel Money, Tigo Pesa ou HaloPesa.",
  crypto: "Criptomoedas",
  cryptoDesc: "Transfira criptomoedas de outra carteira ou corretora.",
  allCountry: "Todos os países",
  allCountryDesc: "Escolha os métodos de depósito disponíveis no seu país.",
},

// Spanish
es: {
  deposit: "Depositar",
  depositMobileMoney: "Depósito por dinero móvil",
  depositMobileMoneyDesc:
    "Deposita al instante con M-Pesa, Airtel Money, Tigo Pesa o HaloPesa.",
  crypto: "Criptomonedas",
  cryptoDesc: "Transfiere criptomonedas desde otra cartera o plataforma de intercambio.",
  allCountry: "Todos los países",
  allCountryDesc: "Elige los métodos de depósito disponibles en tu país.",
},

// Arabic
ar: {
  deposit: "إيداع",
  depositMobileMoney: "الإيداع عبر الأموال عبر الهاتف",
  depositMobileMoneyDesc:
    "أودع فورًا باستخدام M-Pesa أو Airtel Money أو Tigo Pesa أو HaloPesa.",
  crypto: "العملات الرقمية",
  cryptoDesc: "حوّل العملات الرقمية من محفظة أو منصة تداول أخرى.",
  allCountry: "جميع البلدان",
  allCountryDesc: "اختر طرق الإيداع المتاحة في بلدك.",
},

// Chinese
zh: {
  deposit: "存款",
  depositMobileMoney: "手机钱包存款",
  depositMobileMoneyDesc:
    "使用 M-Pesa、Airtel Money、Tigo Pesa 或 HaloPesa 即时存款。",
  crypto: "加密货币",
  cryptoDesc: "从其他钱包或交易所转入加密货币。",
  allCountry: "所有国家",
  allCountryDesc: "选择您所在国家/地区可用的存款方式。",
},

// Hindi
hi: {
  deposit: "जमा करें",
  depositMobileMoney: "मोबाइल मनी से जमा करें",
  depositMobileMoneyDesc:
    "M-Pesa, Airtel Money, Tigo Pesa या HaloPesa से तुरंत जमा करें।",
  crypto: "क्रिप्टो",
  cryptoDesc: "किसी अन्य वॉलेट या एक्सचेंज से क्रिप्टो ट्रांसफर करें।",
  allCountry: "सभी देश",
  allCountryDesc: "अपने देश में उपलब्ध जमा विधियाँ चुनें।",
},

// Bengali
bn: {
  deposit: "জমা দিন",
  depositMobileMoney: "মোবাইল মানির মাধ্যমে জমা",
  depositMobileMoneyDesc:
    "M-Pesa, Airtel Money, Tigo Pesa অথবা HaloPesa ব্যবহার করে সঙ্গে সঙ্গে জমা দিন।",
  crypto: "ক্রিপ্টো",
  cryptoDesc: "অন্য ওয়ালেট বা এক্সচেঞ্জ থেকে ক্রিপ্টো স্থানান্তর করুন।",
  allCountry: "সব দেশ",
  allCountryDesc: "আপনার দেশে উপলব্ধ জমার পদ্ধতি বেছে নিন।",
},

// Russian
ru: {
  deposit: "Пополнить",
  depositMobileMoney: "Пополнение через мобильные деньги",
  depositMobileMoneyDesc:
    "Пополняйте мгновенно через M-Pesa, Airtel Money, Tigo Pesa или HaloPesa.",
  crypto: "Криптовалюта",
  cryptoDesc: "Переведите криптовалюту с другого кошелька или биржи.",
  allCountry: "Все страны",
  allCountryDesc: "Выберите доступные способы пополнения для вашей страны.",
},

// German
de: {
  deposit: "Einzahlen",
  depositMobileMoney: "Einzahlung per Mobile Money",
  depositMobileMoneyDesc:
    "Zahle sofort mit M-Pesa, Airtel Money, Tigo Pesa oder HaloPesa ein.",
  crypto: "Kryptowährung",
  cryptoDesc: "Übertrage Kryptowährungen aus einer anderen Wallet oder Börse.",
  allCountry: "Alle Länder",
  allCountryDesc: "Wähle die in deinem Land verfügbaren Einzahlungsmethoden.",
},

// Italian
it: {
  deposit: "Deposita",
  depositMobileMoney: "Deposito tramite denaro mobile",
  depositMobileMoneyDesc:
    "Deposita subito con M-Pesa, Airtel Money, Tigo Pesa o HaloPesa.",
  crypto: "Criptovalute",
  cryptoDesc: "Trasferisci criptovalute da un altro portafoglio o exchange.",
  allCountry: "Tutti i paesi",
  allCountryDesc: "Scegli i metodi di deposito disponibili nel tuo paese.",
},

// Dutch
nl: {
  deposit: "Storten",
  depositMobileMoney: "Storten via mobiel geld",
  depositMobileMoneyDesc:
    "Stort direct met M-Pesa, Airtel Money, Tigo Pesa of HaloPesa.",
  crypto: "Crypto",
  cryptoDesc: "Verplaats crypto vanuit een andere wallet of exchange.",
  allCountry: "Alle landen",
  allCountryDesc: "Kies de stortingsmethoden die in jouw land beschikbaar zijn.",
},

// Turkish
tr: {
  deposit: "Para Yatır",
  depositMobileMoney: "Mobil Para ile Para Yatır",
  depositMobileMoneyDesc:
    "M-Pesa, Airtel Money, Tigo Pesa veya HaloPesa ile anında para yatır.",
  crypto: "Kripto",
  cryptoDesc: "Başka bir cüzdan veya borsadan kripto transfer et.",
  allCountry: "Tüm Ülkeler",
  allCountryDesc: "Ülkenizde kullanılabilen para yatırma yöntemlerini seçin.",
},

// Japanese
ja: {
  deposit: "入金",
  depositMobileMoney: "モバイルマネーで入金",
  depositMobileMoneyDesc:
    "M-Pesa、Airtel Money、Tigo Pesa、HaloPesaですぐに入金できます。",
  crypto: "暗号資産",
  cryptoDesc: "別のウォレットまたは取引所から暗号資産を送金します。",
  allCountry: "すべての国",
  allCountryDesc: "お住まいの国で利用可能な入金方法を選択してください。",
},

// Korean
ko: {
  deposit: "입금",
  depositMobileMoney: "모바일 머니 입금",
  depositMobileMoneyDesc:
    "M-Pesa, Airtel Money, Tigo Pesa 또는 HaloPesa로 즉시 입금하세요.",
  crypto: "암호화폐",
  cryptoDesc: "다른 지갑이나 거래소에서 암호화폐를 전송하세요.",
  allCountry: "모든 국가",
  allCountryDesc: "해당 국가에서 이용 가능한 입금 방법을 선택하세요.",
},

// Vietnamese
vi: {
  deposit: "Nạp tiền",
  depositMobileMoney: "Nạp tiền qua ví di động",
  depositMobileMoneyDesc:
    "Nạp tiền ngay bằng M-Pesa, Airtel Money, Tigo Pesa hoặc HaloPesa.",
  crypto: "Tiền mã hóa",
  cryptoDesc: "Chuyển tiền mã hóa từ ví hoặc sàn giao dịch khác.",
  allCountry: "Tất cả quốc gia",
  allCountryDesc: "Chọn phương thức nạp tiền có sẵn tại quốc gia của bạn.",
},

// Thai
th: {
  deposit: "ฝากเงิน",
  depositMobileMoney: "ฝากผ่านโมบายมันนี่",
  depositMobileMoneyDesc:
    "ฝากเงินได้ทันทีผ่าน M-Pesa, Airtel Money, Tigo Pesa หรือ HaloPesa",
  crypto: "คริปโต",
  cryptoDesc: "โอนคริปโตจากกระเป๋าเงินหรือเว็บซื้อขายอื่น",
  allCountry: "ทุกประเทศ",
  allCountryDesc: "เลือกวิธีฝากเงินที่มีให้บริการในประเทศของคุณ",
},

// Indonesian
id: {
  deposit: "Deposit",
  depositMobileMoney: "Deposit melalui Uang Seluler",
  depositMobileMoneyDesc:
    "Deposit langsung menggunakan M-Pesa, Airtel Money, Tigo Pesa, atau HaloPesa.",
  crypto: "Kripto",
  cryptoDesc: "Transfer kripto dari dompet atau bursa lain.",
  allCountry: "Semua Negara",
  allCountryDesc: "Pilih metode deposit yang tersedia di negara Anda.",
},

// Malay
ms: {
  deposit: "Deposit",
  depositMobileMoney: "Deposit melalui Wang Mudah Alih",
  depositMobileMoneyDesc:
    "Deposit serta-merta menggunakan M-Pesa, Airtel Money, Tigo Pesa atau HaloPesa.",
  crypto: "Kripto",
  cryptoDesc: "Pindahkan kripto daripada dompet atau bursa lain.",
  allCountry: "Semua Negara",
  allCountryDesc: "Pilih kaedah deposit yang tersedia di negara anda.",
},

// Urdu
ur: {
  deposit: "رقم جمع کریں",
  depositMobileMoney: "موبائل منی کے ذریعے رقم جمع کریں",
  depositMobileMoneyDesc:
    "M-Pesa، Airtel Money، Tigo Pesa یا HaloPesa کے ذریعے فوراً رقم جمع کریں۔",
  crypto: "کرپٹو",
  cryptoDesc: "کسی دوسرے والیٹ یا ایکسچینج سے کرپٹو منتقل کریں۔",
  allCountry: "تمام ممالک",
  allCountryDesc: "اپنے ملک میں دستیاب رقم جمع کرنے کے طریقے منتخب کریں۔",
},

// Persian
fa: {
  deposit: "واریز",
  depositMobileMoney: "واریز از طریق پول موبایلی",
  depositMobileMoneyDesc:
    "با استفاده از M-Pesa، Airtel Money، Tigo Pesa یا HaloPesa فوراً واریز کنید.",
  crypto: "ارز دیجیتال",
  cryptoDesc: "ارز دیجیتال را از کیف پول یا صرافی دیگری منتقل کنید.",
  allCountry: "همه کشورها",
  allCountryDesc: "روش‌های واریز موجود در کشور خود را انتخاب کنید.",
},

// Hausa
ha: {
  deposit: "Ajiye Kuɗi",
  depositMobileMoney: "Ajiye Kuɗi ta Wayar Hannu",
  depositMobileMoneyDesc:
    "Ajiye kuɗi nan take ta amfani da M-Pesa, Airtel Money, Tigo Pesa ko HaloPesa.",
  crypto: "Kuɗin Crypto",
  cryptoDesc: "Canja crypto daga wani walat ko kasuwar musayar kuɗi.",
  allCountry: "Duk Ƙasashe",
  allCountryDesc: "Zaɓi hanyoyin ajiye kuɗi da ake samu a ƙasarku.",
},

// Yoruba
yo: {
  deposit: "Fi Owó Sílẹ̀",
  depositMobileMoney: "Fi Owó Sílẹ̀ Pẹ̀lú Owo Alágbèéká",
  depositMobileMoneyDesc:
    "Fi owó sílẹ̀ lẹ́sẹ̀kẹsẹ̀ nípa lílo M-Pesa, Airtel Money, Tigo Pesa tàbí HaloPesa.",
  crypto: "Owó Crypto",
  cryptoDesc: "Gbé crypto láti inú àpò owó mìíràn tàbí ọjà pàṣípààrọ̀.",
  allCountry: "Gbogbo Àwọn Orílẹ̀-Èdè",
  allCountryDesc: "Yan àwọn ọ̀nà ìfowópamọ́ tí ó wà ní orílẹ̀-èdè rẹ.",
},

// Zulu
zu: {
  deposit: "Faka Imali",
  depositMobileMoney: "Faka Imali Nge-Mobile Money",
  depositMobileMoneyDesc:
    "Faka imali ngokushesha usebenzisa i-M-Pesa, i-Airtel Money, i-Tigo Pesa noma i-HaloPesa.",
  crypto: "I-Crypto",
  cryptoDesc: "Dlulisela i-crypto kwenye i-wallet noma i-exchange.",
  allCountry: "Wonke Amazwe",
  allCountryDesc: "Khetha izindlela zokufaka imali ezitholakala ezweni lakini.",
},

// Amharic
am: {
  deposit: "ገንዘብ አስገባ",
  depositMobileMoney: "በሞባይል ገንዘብ አስገባ",
  depositMobileMoneyDesc:
    "M-Pesa፣ Airtel Money፣ Tigo Pesa ወይም HaloPesa በመጠቀም ወዲያውኑ ገንዘብ ያስገቡ።",
  crypto: "ክሪፕቶ",
  cryptoDesc: "ከሌላ የዲጂታል ቦርሳ ወይም ልውውጥ ክሪፕቶ ያስተላልፉ።",
  allCountry: "ሁሉም አገሮች",
  allCountryDesc: "በአገርዎ የሚገኙ የተቀማጭ ዘዴዎችን ይምረጡ።",
},

// Somali
so: {
  deposit: "Lacag Dhigasho",
  depositMobileMoney: "Lacag ku dhig Mobile Money",
  depositMobileMoneyDesc:
    "Isla markiiba ku shub adigoo adeegsanaya M-Pesa, Airtel Money, Tigo Pesa ama HaloPesa.",
  crypto: "Crypto",
  cryptoDesc: "Crypto ka soo wareeji boorso kale ama sarifle.",
  allCountry: "Dhammaan Dalalka",
  allCountryDesc: "Dooro hababka lacag dhigashada ee laga heli karo dalkaaga.",
},

// Kinyarwanda
rw: {
  deposit: "Shyiramo Amafaranga",
  depositMobileMoney: "Shyiramo Amafaranga ukoresheje Mobile Money",
  depositMobileMoneyDesc:
    "Shyiramo amafaranga ako kanya ukoresheje M-Pesa, Airtel Money, Tigo Pesa cyangwa HaloPesa.",
  crypto: "Crypto",
  cryptoDesc: "Ohereza crypto uyivanye mu yindi wallet cyangwa ku isoko ryayo.",
  allCountry: "Ibihugu Byose",
  allCountryDesc: "Hitamo uburyo bwo gushyiramo amafaranga buboneka mu gihugu cyawe.",
},

// Luganda
lg: {
  deposit: "Teekamu Ssente",
  depositMobileMoney: "Teekamu Ssente ng'oyita ku Mobile Money",
  depositMobileMoneyDesc:
    "Teekamu ssente amangu ng'okozesa M-Pesa, Airtel Money, Tigo Pesa oba HaloPesa.",
  crypto: "Crypto",
  cryptoDesc: "Sindikira crypto okuva mu wallet oba exchange endala.",
  allCountry: "Amawanga Gonna",
  allCountryDesc: "Londa engeri z'okuteekamu ssente eziri mu nsi yo.",
},

// Afrikaans
af: {
  deposit: "Deponeer",
  depositMobileMoney: "Deponeer met mobiele geld",
  depositMobileMoneyDesc:
    "Deponeer onmiddellik met M-Pesa, Airtel Money, Tigo Pesa of HaloPesa.",
  crypto: "Kripto",
  cryptoDesc: "Dra kripto oor vanaf 'n ander beursie of beurs.",
  allCountry: "Alle lande",
  allCountryDesc: "Kies depositometodes wat in jou land beskikbaar is.",
},
};


export default function Deposit() {
  const navigate = useNavigate();

  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem("language") || "en");
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const t = translations[language] || translations.en;

  const items = [
    {
      title: t.depositMobileMoney,
      desc: t.depositMobileMoneyDesc,
      icon: <FaMoneyBillWave />,
      path: "/deposittzmobile",
    },
    {
      title: t.crypto,
      desc: t.cryptoDesc,
      icon: <FaBitcoin />,
      path: "/deposit/crypto",
    },
    {
      title: t.allCountry,
      desc: t.allCountryDesc,
      icon: <FaGlobe />,
      path: "/Country-Selector",
    },
  ];

  return (
    <div className="deposit-page">
      <div className="deposit-header">
        <FaArrowLeft
          className="back-icon"
          onClick={() => navigate(-1)}
        />

        <h2>{t.deposit}</h2>

        <div></div>
      </div>

      <div className="deposit-sheet">
        <div className="sheet-bar"></div>

        {items.map((item, index) => (
          <div
            key={index}
            className="deposit-item"
            onClick={() => navigate(item.path)}
          >
            <div className="deposit-left">
              <div className="deposit-icon">{item.icon}</div>

              <div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>

            <FaChevronRight className="arrow" />
          </div>
        ))}
      </div>
    </div>
  );
}